import type { ReactNode } from 'react'
import './SoftseeToolbar.css'

/**
 * Randul de deasupra tabelului in filele Softsee din fisa aparatului: cautarea
 * si filtrul filei pe ACELASI rand, nu unul sub altul.
 *
 * Pana acum filtrul (Period, Kits / Custom Kits) statea pe randul lui, iar
 * cautarea pe randul barii DataTables, dedesubt - doua randuri pentru doua
 * unelte care lucreaza impreuna. Aici sunt fratii unui singur rand flex, in
 * ordinea in care le scrie fila; `SoftseeToolbarEnd` impinge ce primeste la
 * marginea din dreapta.
 *
 * Latimile nu se scriu de mana: invelisul listei poarta `form-inline`, deci un
 * `.form-control` iese `inline-block` si cat ii cere continutul - cat selectul
 * "Show 10 entries" din subsol. Cautarea isi pastreaza masurile din `app.css`
 * (`.dataTableF`: 280px, 34px); `SoftseeToolbar.css` scoate doar latimea fixa
 * si floatul invelisului ei, care altfel ar calca peste vecin.
 */
export function SoftseeToolbar({ children }: { children: ReactNode }) {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="softsee-toolbar">{children}</div>
      </div>
    </div>
  )
}

/** Ce sta la dreapta randului (cautarea din Install applications). */
export function SoftseeToolbarEnd({ children }: { children: ReactNode }) {
  return <div className="softsee-toolbar-end">{children}</div>
}
